import httpService from "../../Service/httpService";

const controller = "Kpis";

export const getResumenCitas = async (id) => {
  const res = await httpService.get(
    `/${controller}/getResumenCitas/${id}`
  );
  return res.data;
};

export const getPacientesTotal = async (id) => {
  const res = await httpService.get(
    `/${controller}/getPacientesTotal/${id}`
  );
  return res.data;
};

export const getPacientesRecientes = async (id) => {
  const res = await httpService.get(
    `/${controller}/getPacientesRecientes/${id}`
  );
  return res.data;
};
